
// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Injectable } from '@angular/core';
import { BCGrowls } from '../../shared/library/bcGrowls';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// GrowlWrapperService
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Injectable()
export class GrowlWrapperService{

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================    
    // constructor
    //==================================
    constructor(){};

    //==================================
    // getGrowlBox
    //==================================
    getGrowlBox(containerElementId) {
        
        let growlBox = new BCGrowls("growlBox"); //Probably never need >1 growlbox on a page, so just default the name

        if (containerElementId) {
		    growlBox.init({ appendToElementId:this.containerElementId }); 
        }
        else {
            growlBox.init();
        }

        return growlBox;
    }

    
}
